import { createConfigParametersRepository } from '../../configParametersRepository';
import { parseStringToParams } from '../../utils/object';
import {
  MKTTRACK_COOKIE_NAME,
  UTM_CAMPAIGN_KEY,
  UTM_CONTENT_KEY,
  UTM_GCLID_KEY,
  UTM_MEDIUM_KEY,
  UTM_SOURCE_KEY,
  UTM_TERM_KEY,
} from '../resources/constants';

const mktTrackToUtm: Record<string, string> = {
  utmcsr: UTM_SOURCE_KEY,
  utmcmd: UTM_MEDIUM_KEY,
  utmccn: UTM_CAMPAIGN_KEY,
  utmcct: UTM_CONTENT_KEY,
  utmctr: UTM_TERM_KEY,
  utmgclid: UTM_GCLID_KEY,
};

const parseTracktoUtm = (mktTrack: string) => mktTrackToUtm[mktTrack];

export const getUtmParameters = () => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const cookie = storageClient?.getCookie(MKTTRACK_COOKIE_NAME) || '';
  return getUtmParamsByCookie(cookie);
};

export const getUtmParamsByCookie = (cookie: string) => {
  const utmParams = parseStringToParams(cookie, {
    paramsSeparator: '|',
    keyValueSeparator: '=',
    parseKey: parseTracktoUtm,
  });
  const isCmdNotSet =
    decodeURI(utmParams[mktTrackToUtm.utmcmd]) === '(not set)';
  if (isCmdNotSet && mktTrackToUtm.utmgclid) {
    utmParams[mktTrackToUtm.utmcmd] = 'cpc';
    utmParams[mktTrackToUtm.utmcsr] = 'google';
  }
  return utmParams;
};
